import { Translator } from '../Translator';
import { translate } from './translate';
import {
  BUTTON_FOR_MULTIMEDIA2,
  ItemIds,
  VIDEO
} from '~/training/sequence/templates/items';
import { ItemDefinition } from '~/training/sequence/templates/items/Item';

/**
 * Multimedia2: learner Auto Play alone decides whether the video starts.
 * Force author `autoPlay` on so Video's `autoPlay && autoPlayFromSetting`
 * gate ignores the server flag for this template only.
 */
function forceVideoAutoPlay(items: ItemDefinition<ItemIds>[] | undefined) {
  if (!items) return;
  for (const item of items) {
    if (item.type === VIDEO) {
      item.values = {
        ...(item.values as Record<string, unknown>),
        autoPlay: true
      } as typeof item.values;
    }
    forceVideoAutoPlay(item.items);
  }
}

export const Multimedia2: Translator = sequence => {
  const root = translate(sequence, () => {
    return null;
  });

  forceVideoAutoPlay(root?.items);

  root?.items?.push({
    type: BUTTON_FOR_MULTIMEDIA2,
    id: 'play_btn',
    values: {},
    items: []
  });

  return root;
};
